import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { filter, map, Observable } from 'rxjs';

import { LoadingStatus } from '../../../../core/domain/events/state_provider';
import { PatientStateProvider } from '../../../../data/patient/domain/patient_state_provider';

@Injectable()
export class MyChartGuard implements CanActivate {
  constructor(
    private router: Router,
    private patientStateProvider: PatientStateProvider,
  ) {
    // nada
  }

  canActivate():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.patientStateProvider.state$
      .pipe(
        filter((s) => s.loading != LoadingStatus.LOADING), // ignore loading
      )
      .pipe(
        map((e) => {
          // if not signed as patient, redirect to auth
          if (e.entity && !e.entity.isSharedSeries) {
            return this.router.createUrlTree(['/my', 'home']);
          }

          return true;
        }),
      );
  }
}
